import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import { fg } from '@atlaskit/platform-feature-flags';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import { getPreferences } from '../../../controllers/preferences-controls/get-preferences';
import { PreferenceCategory } from '../../../types';
import { getBscGlobalState } from '../bsc-global-state';
import { isProcessingAllowedByPreferencesLegacy } from '../item-processing-legacy';
export var findStartsWithPatternMatch = function findStartsWithPatternMatch(itemKey, startsWith) {
  // Setup initial pattern step and position
  var currentStep = startsWith;
  var position = 0;

  // Iterate through item key symbol by symbol
  while (position < itemKey.length) {
    // The value of item character at the position
    var currentStepValue = currentStep[itemKey[position]];
    // If there is no match for item symbol in cache, this means there is no
    // pattern match for the item key
    if (currentStepValue === undefined) {
      return null;
    }
    // If current step value is a number, this means we reached the end of the pattern
    // and should return category number
    if (typeof currentStepValue === 'number') {
      return currentStepValue;
    }
    // Continue to going through pattern
    currentStep = currentStepValue;
    position++;
  }

  // No pattern match - all patterns longer or shorter than item key
  return null;
};
export var findEndsWithPatternMatch = function findEndsWithPatternMatch(itemKey, endsWith) {
  // Return category number if str is found in the trie, otherwise return undefined
  var trieSearch = function trieSearch(str) {
    var currentStep = endsWith;
    var foundString = '';
    var terminalNumber;
    for (var i = 0; i < str.length; i++) {
      var char = str[i];
      currentStep = currentStep[char];
      if (currentStep === undefined) {
        break;
      }
      foundString += char;
      if (typeof currentStep === 'number') {
        terminalNumber = currentStep;
        break;
      }
    }
    if (foundString === str) {
      // Trie contained the complete string
      return terminalNumber;
    } else {
      // Trie did not contain the complete string
      return undefined;
    }
  };
  var position = 0;

  // Iterate through item key symbol by symbol
  while (position < itemKey.length) {
    var remainderMatch = trieSearch(itemKey.slice(position));
    if (remainderMatch !== undefined) {
      return remainderMatch;
    }
    position++;
  }
  return null;
};

/**
 * Synchronously fetches a an item/cookie category from a CategorizedStorageControlsCache that has already been fetched
 *
 * This allows synchronous parts of the code to access cached versions of the cache but still maintain
 * a synchronous signature for clients
 *
 */
export var getItemCategoryFromPassedCache = function getItemCategoryFromPassedCache(itemKey, storageControlsData, productName) {
  var _numToCategoryMap;
  var itemCategoryNumber = null;
  var categories = storageControlsData.categories,
    patterns = storageControlsData.patterns;
  var productKeys = _objectSpread(_objectSpread({}, storageControlsData['keys']['all']), productName ? storageControlsData['keys'][productName] : {});
  var productStartsWithPatterns = _objectSpread(_objectSpread({}, patterns.startsWith['all']), productName ? patterns.startsWith[productName] : {});
  var productEndsWithPatterns = _objectSpread(_objectSpread({}, patterns.endsWith['all']), productName ? patterns.endsWith[productName] : {});

  // Find direct match in keys
  if (Object.keys(productKeys).includes(itemKey)) {
    itemCategoryNumber = productKeys[itemKey];
  } else {
    // Find pattern match or null
    itemCategoryNumber = findStartsWithPatternMatch(itemKey, productStartsWithPatterns);
    if (itemCategoryNumber === null) {
      itemCategoryNumber = findEndsWithPatternMatch(itemKey, productEndsWithPatterns);
    }
  }
  var numToCategoryMap = (_numToCategoryMap = {}, _defineProperty(_numToCategoryMap, categories.STRICTLY_NECESSARY, PreferenceCategory.StrictlyNecessary), _defineProperty(_numToCategoryMap, categories.FUNCTIONAL, PreferenceCategory.Functional), _defineProperty(_numToCategoryMap, categories.ANALYTICS, PreferenceCategory.Analytics), _defineProperty(_numToCategoryMap, categories.MARKETING, PreferenceCategory.Marketing), _defineProperty(_numToCategoryMap, categories.UNKNOWN, PreferenceCategory.Unknown), _numToCategoryMap);
  return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
export var getItemCategory = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(itemKey, storageType, productName) {
    var storageControlsData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getBscGlobalState().loadCache(storageType);
        case 2:
          storageControlsData = _context.sent;
          if (storageControlsData) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", null);
        case 7:
          return _context.abrupt("return", getItemCategoryFromPassedCache(itemKey, storageControlsData, productName));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getItemCategory(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Given an item key (WebStorage key or cookie name), fetches preferences and categories and determines whether the key can be set
 *
 * Allows an optional allowedCallback to be passed which is invoked in the case the cookie is allowed to be set.
 * This allows synchronous parts of the code to check a item's status (e.g. the localStorage or document.cookie overrides)
 *
 */
export var isProcessingAllowedByPreferences = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var itemKey, _ref2$allowedCallback, allowedCallback, _ref2$blockedCallback, blockedCallback, storageType, productName, shouldProcessItem, itemCategory, preferences, hasPreferencesForCategory;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          itemKey = _ref2.itemKey, _ref2$allowedCallback = _ref2.allowedCallback, allowedCallback = _ref2$allowedCallback === void 0 ? function () {} : _ref2$allowedCallback, _ref2$blockedCallback = _ref2.blockedCallback, blockedCallback = _ref2$blockedCallback === void 0 ? function () {} : _ref2$blockedCallback, storageType = _ref2.storageType, productName = _ref2.productName;
          if (fg('platform_moonjelly_bsc_new_caches')) {
            _context2.next = 5;
            break;
          }
          _context2.next = 4;
          return isProcessingAllowedByPreferencesLegacy({
            itemKey: itemKey,
            allowedCallback: allowedCallback,
            blockedCallback: blockedCallback
          });
        case 4:
          return _context2.abrupt("return", _context2.sent);
        case 5:
          _context2.next = 7;
          return getItemCategory(itemKey, storageType, productName);
        case 7:
          itemCategory = _context2.sent;
          if (!(itemCategory === PreferenceCategory.StrictlyNecessary)) {
            _context2.next = 12;
            break;
          }
          shouldProcessItem = true;
          _context2.next = 18;
          break;
        case 12:
          _context2.next = 14;
          return getPreferences();
        case 14:
          preferences = _context2.sent;
          hasPreferencesForCategory = false;
          if (!!preferences) {
            if (!!itemCategory) {
              hasPreferencesForCategory = preferences[itemCategory];
            }
          }
          shouldProcessItem = hasPreferencesForCategory;
        case 18:
          if (shouldProcessItem) {
            allowedCallback === null || allowedCallback === void 0 || allowedCallback();
          } else {
            blockedCallback === null || blockedCallback === void 0 || blockedCallback({
              itemHasCategory: itemCategory != null
            });
          }
          return _context2.abrupt("return", shouldProcessItem);
        case 20:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function isProcessingAllowedByPreferences(_x4) {
    return _ref3.apply(this, arguments);
  };
}();